import autoRslaWorksheetApi from './auto-rsla-worksheet/auto-rsla-worksheet-api'
import worksheetApi from './auto-worksheet/auto-worksheet-api'
import availableCreditApi from './available-credit-api'
import b2cWorksheetApi from './b2c-worksheet/b2c-worksheet-api'
import bankAccountRequestApi from './bank-account-request/bank-account-request-api'
import configApi from './config/config-api'
import contractApi from './credit-application-contract/credit-application-contract'
import creditApplicationHistoryApi from './credit-application-history/credit-application-history-api'
import creditApplicationApi from './credit-application/credit-application-api'
import creditDashboardEntriesApi from './credit-dashboard-entry/credit-DashboardEntries-api'
import loanApi from './credit-loan/credit-application-loan'
import creditRslaWorksheetApi from './credit-rsla-worksheet/credit-rsla-worksheet-api'
import creditTaskCommentApi from './credit-task-comment/credit-task-comment-api'
import creditTaskDashboardEntriesApi from './credit-task-dashboard-entry/credit-task-DashboardEntries-api'
import creditTaskApi from './credit-task/credit-task-api'
import customerReferenceApi from './customer-reference/customer-reference-api'
import documentApi from './document/document-api'
import electronicSignatureApi from './electronic-sign/electronic-sign-api'
import creditDecisionApi from './final-credit-decision/final-credit-decision-api'
import fullCreditApplicationApi from './full-credit-application/full-credit-application-api'
import ifXpressWorksheetApi from './ifxpress-worksheet/ifxpress-worksheet-api'
import loanCustomerApi from './loan-customer/loan-customer-api'
import mechanicalWarrantyWorksheetApi from './mechanical-warranty-worksheet/mechanical-warranty-worksheet-api'
import messageApi from './message/message-api'
import personalLoanWorksheetApi from './personal-loan-worksheet/personal-loan-worksheet-api'
import previousApplicationApi from './previous-application/previous-application-api'
import productsWorksheetApi from './products-worksheet/products-worksheet-api'
import refinancingApi from './refinancing-api'
import reportApi from './report/report-api'
import reportActApi from './report/reportAct-api'
import reportAllApplicationApi from './report/reportAllApplication-api'
import reportBenoitApi from './report/reportBenoit-api'
import userApi from './user/user-api'
import vehicleApi from './vehicle/vehicle-api'

export default {
  credit: creditApplicationApi,
  config: configApi,
  user: userApi,
  creditTask: creditTaskApi,
  creditTaskComment: creditTaskCommentApi,
  creditDecision: creditDecisionApi,
  worksheet: worksheetApi,
  document: documentApi,
  creditTaskDashboardEntries: creditTaskDashboardEntriesApi,
  previousapplication: previousApplicationApi,
  vehicle: vehicleApi,
  message: messageApi,
  history: creditApplicationHistoryApi,
  creditDashboardEntries: creditDashboardEntriesApi,
  contract: contractApi,
  fullCredit: fullCreditApplicationApi,
  refinancing: refinancingApi,
  loan: loanApi,
  bankAccountRequest: bankAccountRequestApi,
  personalLoan: personalLoanWorksheetApi,
  b2cWorksheet: b2cWorksheetApi,
  ifxpressWorksheet: ifXpressWorksheetApi,
  autoRslaWorsheet: autoRslaWorksheetApi,
  creditRslaWorsheet: creditRslaWorksheetApi,
  productsWorksheet: productsWorksheetApi,
  availableCredit: availableCreditApi,
  electronicSignature: electronicSignatureApi,
  customerReference: customerReferenceApi,
  loanCustomer: loanCustomerApi,
  report: reportApi,
  reportAllApplication: reportAllApplicationApi,
  reportBenoit: reportBenoitApi,
  reportAct: reportActApi,
  mechanicalWarrantyWorksheet: mechanicalWarrantyWorksheetApi,
}
